import cx from "classnames";
import React from "react";

import { faqIndexUrl } from "@/mk2/apps/faq/urls";
import { Link } from "@/mk2/components/Link";
import { getAllDescendantsOfTypes } from "@/mk2/helpers/article_ast/utils";
import { url } from "@/mk2/helpers/urls";
import { AST } from "@/mk2/schemas";
import { TABLE_OF_CONTENTS } from "@/mk/autogenerated/translations/TableOfContents.ec9c6a5c075f88f2f5c62d28cce9b9bd";
import { slugify } from "@/mk/common/utils";

import styles from "./TableOfContents.mscss";

interface OwnProps {
    articleSlug: string;
    bodyAST: AST;
}

type Props = OwnProps;

export class TableOfContents extends React.PureComponent<Props> {
    public render() {
        const { articleSlug, bodyAST } = this.props;

        const headings = getAllDescendantsOfTypes(bodyAST, ["h2"]).filter(
            (elem) => elem.elements && elem.elements.length > 0,
        );

        if (headings.length === 0) {
            return null;
        }

        return (
            <div className={styles.TableOfContents}>
                <h2 className={styles.TableOfContents__caption}>{TABLE_OF_CONTENTS}</h2>

                <div className={styles.TableOfContents__toc}>
                    <ol className={styles.TableOfContents__toc__list}>
                        {headings.map((elem, idx) => (
                            <li key={idx}>
                                <Link
                                    to={{
                                        pathname: url(faqIndexUrl, { articleSlug }),
                                        hash: "h-" + slugify(elem.elements[0].text),
                                    }}
                                    state={{
                                        dontScrollOnPush: true,
                                    }}
                                >
                                    <div
                                        className={cx(
                                            styles.TableOfContents__toc__list__div,
                                            styles[`TableOfContents__toc__${elem.type}`],
                                        )}
                                    >
                                        {elem.elements[0].text}
                                    </div>
                                </Link>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        );
    }
}

export default TableOfContents;
